'use strict'

/**
 * Helper class for reading (parsing) audio from raw
 * data through the WebAudio API.
 * Format support is browser/platform dependent, but will
 * most likely support at least:
 *  - wav
 *  - aiff
 *  - mp3
 *  - ogg
 */
export class AudioFile
{
  /** Creates a new, empty AudioFile object.
   * @constructor
   */
  constructor()
  {
    this.audioData = undefined; // double-precision floats
    this.sampleCount = undefined;
    this.dataLength = undefined; // in bytes
    this.numChannels = undefined; // only 1st channel actually read
    this.sampleRate = undefined;
    //this.bitsPerSample = undefined; // fixed at 16

    // Create WebAudio context
    // https://stackoverflow.com/questions/34880729/simple-way-to-test-if-the-browser-supports-the-web-audio-api
    let contextFactory = (window.AudioContext ||
      window.webkitAudioContext ||
      window.mozAudioContext ||
      window.oAudioContext ||
      window.msAudioContext);
    if (!contextFactory) throw new Error(
      'Cannot read audio file: WebAudio not supported.');
    this.context = new contextFactory();
  }

  /** Asynchronously reads (parses) audio data and metadata from
   * the specified audio file data
   * @param {ArrayBuffer} fileData - Raw audio file data.
   * @returns {Promise} Promise of read finished (or error).
   */
  readFileData(fileData)
  {
    assert(fileData instanceof ArrayBuffer);
    return new Promise((resolve, reject) => {
      let result = this.context.decodeAudioData(fileData);
      result.then(audioBuffer => {
        // process audio buffer
        this.sampleCount = audioBuffer.length;
        this.numChannels = 1; // 1st channel only, for now...
        this.sampleRate = audioBuffer.sampleRate;
        this.dataLength = audioBuffer.length * this.bitsPerSample / 8;

        //this.bitsPerSample = 16; // fixed, for now...
        // // Convert to 16-bit signed
        // let dest = new Int16Array(this.sampleCount);
        // let srcData = audioBuffer.getChannelData(0); // 1st channel only, for now...
        // for (let i = 0; i < this.sampleCount; i++) {
        //   let src = srcData[i];
        //   dest[i] =  Math.min(32767, Math.max(-32768, Math.floor(src * 32767.0)));
        // }
        //this.audioData = dest;

        this.audioData = audioBuffer.getChannelData(0);

        resolve(this);
      },
      error => reject('NOT_SUPPORTED_FORMAT: ' + error)
    )});
  }
}



// WEBPACK FOOTER //
// ./src/sds/audioFile.js